import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { references } from '../../data/references';
export function References() {
  const [featured, ...others] = references;
  return <section aria-labelledby="references-title" className="py-20 lg:py-28" data-id="element-139" data-mp="2gmlilthxir1o">
      <div className="mx-auto max-w-site px-6 lg:px-10" data-id="element-140" data-mp="2bu28j6igae1m">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-141" data-mp="2bshdzgw4yv3r">
          <h2 id="references-title" className="font-serif text-4xl leading-tight tracking-tight text-ink lg:text-5xl" data-id="element-142" data-mp="2ql1ba0wlu8da">
            Références récentes
          </h2>
          <Link to="/references" className="inline-flex items-center gap-2 self-start border-b border-ink pb-1 text-[15px] text-ink transition-colors duration-150 hover:border-accent hover:text-accent md:self-auto" data-id="element-143" data-mp="2zilgtm1i2qtp">
            Toutes nos références
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-144" data-mp="107tzy8al4y5k" />
          </Link>
        </div>

        <article className="mt-12 grid gap-8 border-t border-ink pt-10 lg:grid-cols-12 lg:gap-10" data-id="element-145" data-mp="27utdruj7b4zq">
          <Link to="/references" className="group block overflow-hidden lg:col-span-7" data-id="element-146" data-mp="2ctwjziax3h9a">
            <img src={featured.image} alt={featured.alt} className="aspect-[3/2] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-147" data-mp="2hro964k6gp9s" />
          </Link>
          <div className="flex flex-col lg:col-span-5" data-id="element-148" data-mp="2qmcge09bch18">
            <p className="text-sm text-accent" data-id="element-149" data-mp="2vijljqtvxoi4">{featured.category}</p>
            <h3 className="mt-4 font-serif text-3xl leading-snug text-ink" data-id="element-150" data-mp="30ifqptebjlz9">
              <Link to="/references" className="hover:text-accent" data-id="element-151" data-mp="30gcrcira0ghv">
                {featured.title}
              </Link>
            </h3>
            <p className="mt-5 text-[17px] leading-relaxed text-muted" data-id="element-152" data-mp="164y01xima900">{featured.summary}</p>
            <dl className="mt-auto grid grid-cols-2 gap-4 border-t border-line pt-6 text-sm max-lg:mt-8" data-id="element-153" data-mp="1b2zkomvoygdl">
              <div data-id="element-154" data-mp="132a56qmbico1">
                <dt className="text-muted" data-id="element-155" data-mp="133l5gggk12ae">Maître d’ouvrage</dt>
                <dd className="mt-1 text-ink" data-id="element-156" data-mp="y3yteacgps36">{featured.client}</dd>
              </div>
              <div data-id="element-157" data-mp="1d0zkqcqqrl14">
                <dt className="text-muted" data-id="element-158" data-mp="1d1itp3yeyz30">Région</dt>
                <dd className="mt-1 text-ink" data-id="element-159" data-mp="1cywlr37m2hk9">{featured.location}</dd>
              </div>
              <div data-id="element-160" data-mp="180lbwshbg721">
                <dt className="text-muted" data-id="element-161" data-mp="18497rya8h5jx">Période</dt>
                <dd className="mt-1 text-ink" data-id="element-162" data-mp="1m0mfifoytsl7">{featured.period}</dd>
              </div>
            </dl>
          </div>
        </article>

        <div className="mt-14 grid gap-10 md:grid-cols-2" data-id="element-163" data-mp="1h0i597enhu3f">
          {others.map(ref => <article key={ref.title} className="group grid grid-cols-[120px_1fr] gap-6 sm:grid-cols-[180px_1fr]" data-id="element-164" data-mp="1vtjz6p5p1nle">
              <Link to="/references" className="block overflow-hidden" tabIndex={-1} aria-hidden="true" data-id="element-165" data-mp="1quqmgyy8e0ma">
                <img src={ref.image} alt="" className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-166" data-mp="20qk7l6q0n2fo" />
              </Link>
              <div className="flex flex-col" data-id="element-167" data-mp="2ocnufz551a2c">
                <p className="text-sm text-accent" data-id="element-168" data-mp="2ae6a8befyfp6">{ref.category}</p>
                <h3 className="mt-2 font-serif text-xl leading-snug text-ink" data-id="element-169" data-mp="2adwiojdr00hd">
                  <Link to="/references" className="hover:text-accent" data-id="element-170" data-mp="2fbxzsyrm5pq7">
                    {ref.title}
                  </Link>
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-171" data-mp="25f31ogz95rcg">{ref.summary}</p>
                <p className="mt-auto pt-3 text-sm text-ink-soft" data-id="element-172" data-mp="25gxq459qg1la">
                  {ref.location} · {ref.period}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}